import { BaseApi } from "./BaseApi";
import { PagedMessageResponse } from "../types/PagedMessageResponse";
import globalMU from "globalMU";
import { AxiosRequestConfig } from "axios";
import { DadosEnviarWhatsapp } from "app/types/modalImprimir/DadosEnviarWhatsapp";
import { ConfigurarWhatsappResponse } from "app/types/Whatsapp/ConfigurarWhatsappResponse";
import { StatusWhatsappResponse } from "app/types/Whatsapp/StatusWhatsappResponse";
import { EnviarWhatsappOutput } from "app/types/Whatsapp/EnviarWhatsappOutput";
import { DadosEnviarWhatsappMuWhatsappApi } from "app/types/modalImprimir/DadosEnviarWhatsappMuWhatsappApi";




export class WhatsappApi extends BaseApi {
    url(path: string): string {
        return `${globalMU.enterpriseUrl()}/api/${path}`;
    }

    async obterStatusWhatsappVendedor(codigoVendedor: string): Promise<StatusWhatsappResponse> {
        if (!codigoVendedor) {
            throw new Error("Código do vendedor não pode ser vazio.");
        }
        
        const token = globalMU.token();

        const config: AxiosRequestConfig = {
            headers: {
                Authorization: token,
                Accept: "*/*",
                "Content-Type": "application/json",
            }
        };


        const resposta = await this.Enterprise.get(this.url("whatsapp/statussessao"), { ...config, params: { codigoVendedor, codigo: codigoVendedor, tipo: "VENDEDOR" } });
        return resposta.data;
    }

    async obterStatusWhatsappSessaoPadrao(): Promise<StatusWhatsappResponse> {

        const token = globalMU.token();

        const config: AxiosRequestConfig = {
            headers: {
                Authorization: token,
                Accept: "*/*",
                "Content-Type": "application/json",
            }
        };


        const resposta = await this.Enterprise.get(this.url("whatsapp/statussessao"), { ...config, params: {  tipo: "SESSAOPADRAO" } });
        return resposta.data;
    }

    async obterStatusWhatsappSessaoFilial(codigoFilial: string): Promise<StatusWhatsappResponse> {
        if (!codigoFilial) {
            throw new Error("Código do vendedor não pode ser vazio.");
        }
        
        const token = globalMU.token();

        const config: AxiosRequestConfig = {
            headers: {
                Authorization: token,
                Accept: "*/*",
                "Content-Type": "application/json",
            }
        };


        const resposta = await this.Enterprise.get(this.url("whatsapp/statussessao"), { ...config, params: {  codigo: codigoFilial, tipo: "FILIAL" } });
        return resposta.data;
    }
    async enviarWhatsappVendedor(dados: DadosEnviarWhatsappMuWhatsappApi, codigoVendedor: string): Promise<EnviarWhatsappOutput> {
        
        if (!codigoVendedor) {
            throw new Error("Código do vendedor não pode ser vazio.");
        }

        const token = globalMU.token();
        const config: AxiosRequestConfig = {
            headers: {
                Authorization: token,
                Accept: "*/*",
                "Content-Type": "application/json",
            }
        };

        const resposta = await this.Enterprise.post(
            this.url("whatsapp/enviarmensagem"),
            dados,
            { ...config, params: { codigoVendedor, codigo: codigoVendedor, tipo: "VENDEDOR" } }
        );
        return resposta.data;
    }

    async enviarWhatsappFilial(dados: DadosEnviarWhatsappMuWhatsappApi, codigoFilial: string): Promise<EnviarWhatsappOutput> {

        if (!codigoFilial) {
            throw new Error("Código da filial não pode ser vazio.");
        }

        const token = globalMU.token();
        const config: AxiosRequestConfig = {
            headers: {
                Authorization: token,
                Accept: "*/*",
                "Content-Type": "application/json",
            }
        };

        const resposta = await this.Enterprise.post(
            this.url("whatsapp/enviarmensagem"),
            dados,
            { ...config, params: { codigo: codigoFilial, tipo: "FILIAL" } }
        );
        return resposta.data;
    }

    async enviarWhatsappSessaoPadrao(dados: DadosEnviarWhatsappMuWhatsappApi): Promise<EnviarWhatsappOutput> {
        const token = globalMU.token();
        const config: AxiosRequestConfig = {
            headers: {
                Authorization: token,
                Accept: "*/*",
                "Content-Type": "application/json",
            }
        };

        const resposta = await this.Enterprise.post(
            this.url("whatsapp/enviarmensagem"),
            dados,
            { ...config, params: {tipo: "SESSAOPADRAO" } }
        );
        return resposta.data;
    }


    async obterNumeroWhatsappVendedor(codigoVendedor: string): Promise<string> {
       
        if (!codigoVendedor) {
            throw new Error("Código do vendedor não pode ser vazio.");
        }
        const token = globalMU.token();
        const config: AxiosRequestConfig = {
            headers: {
                Authorization: token,
                Accept: "*/*",
                "Content-Type": "application/json",
            }
        };

        const resposta = await this.Enterprise.get(this.url("whatsapp/obternumero"), { ...config, params: { codigoVendedor, codigo: codigoVendedor, tipo: "VENDEDOR" } });
        return resposta.data;
    }


    async removerWhatsappVendedor(codigoVendedor: string): Promise<boolean> {
        
        if (!codigoVendedor) {
            throw new Error("Código do vendedor não pode ser vazio.");
        }
        const token = globalMU.token();

        const config: AxiosRequestConfig = {
            headers: {
                Authorization: token,
                Accept: "*/*",
                "Content-Type": "application/json",
            }
        };

       return await this.Enterprise.delete(this.url("whatsapp"), { ...config, params: { codigoVendedor, codigo: codigoVendedor, tipo: "VENDEDOR"} });
    }

    async configurarWhatsappVendedor(codigoVendedor: string): Promise<ConfigurarWhatsappResponse> {
        if (!codigoVendedor) {
            throw new Error("Código do vendedor não pode ser vazio.");
        }

        const token = globalMU.token();
        const config: AxiosRequestConfig = {
            headers: {
                Authorization: token,
                Accept: "*/*",
                "Content-Type": "application/json",
            }
        };

        const resposta = await this.Enterprise.post(
            this.url("whatsapp/configurar"),
            {},
            { ...config, params: { codigoVendedor, codigo: codigoVendedor, tipo: "VENDEDOR" } }   
        );
        return resposta.data;
    }

}
